import React from 'react';
import moment from 'moment';
import global from '../../../../common/utility/global';
import { FORMAT_2DECIMALS ,FORMAT_3DECIMALS , GREATER_THAN_ZERO} from '../../../../common/types/regularExpresionType';
import { Table, Empty, Button, Input, Form, Select, DatePicker, Icon } from 'antd';
const { Option } = Select;

export default function Cuotas(props) {
    return (
        <div>
            <Table
                style={{ overflowX: 'auto' }}
                className={'table-cuota'}
                size="small"
                pagination={false}
                dataSource={props.dataSource}
                rowKey={record => record.identifier}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='Pulse el botón "+ Agregar".'
                    />
                }}
                columns={[
                    {
                        key: 'remove-button',
                        align: 'center',
                        width: '50px',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Button
                                        type="danger"
                                        icon="delete"
                                        size={"small"}
                                        onClick={() => props.onRemove(value)}
                                    />
                                </div>
                            </span>
                        )
                    },

                    {
                        title: 'Cuota',
                        dataIndex: 'correlativo',
                        key: 'correlativo',
                        align: 'center',
                        width: '100px',
                        render: (value, row) => {
                            
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrCorrelativo[${row.identifier}]`, {
                                        initialValue: value
                                    
                                    })(
                                        <Input
                                        className="text-center"
                                        onKeyPress={global.onKeyPressDecimals}
                                        placeholder=""
                                        autoComplete="off"
                                        disabled={true}
                                    />
                                    )}
                                </Form.Item>
                            );
                        }
                    },

                    {
                        title: 'Fecha Vencimiento',
                        dataIndex: 'fechaVencimiento',
                        key: 'fechaVencimiento',
                        align: 'center',
                        // width: 120,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrVencimiento[${row.identifier}]`, {
                                        initialValue: moment(value, 'DD/MM/YYYY'),
                                        rules: [{
                                            required: true,
                                            message: "Formato (dd/mm/yyyy)"
                                        }]
                                    })(
                                        <DatePicker
                                            className="first-input"
                                            placeholder="dd/mm/yyyy"
                                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                            format="DD/MM/YYYY"
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },

         

                    {
                        title: 'Monto de Cuota',
                        dataIndex: 'montoCuota',
                        key: 'montoCuota',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrMontoCuota[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(3),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_3DECIMALS),
                                            message: "Formato (0.000)"
                                        },
                                        {
                                            required: true,
                                            pattern: new RegExp(GREATER_THAN_ZERO),
                                            message: "Monto de Cuota debe ser mayor a 0"
                                        }]
                                    })(
                                        <Input
                                            className="text-right"
                                            onKeyPress={global.onKeyPressDecimals}
                                            placeholder="Ingresar Monto de Cuota"
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Estado',
                        dataIndex: 'estado',
                        key: 'estado',
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                {props.onGetFieldDecorator(`arrEstado[${row.identifier}]`, {
                                    initialValue:  value
                                
                                })(
                                    <Input
                                    placeholder=""
                                    autoComplete="off"
                                    disabled={true}
                                />
                                )}
                            </Form.Item>

                            //     <Form.Item>
                            //   <Select showSearch labelInValue
                            //                 placeholder={"Seleccione Tipo Comprobante"}
                            //                 optionFilterProp="children"
                            //             >
                            //           <Option key={1} value={"Pendiente"}>{"Pendiente"}</Option>
                            //             </Select>
                                    
                            //     </Form.Item>
                            );
                        }
                    },
                ]}
            />
        </div>
    );
}